import React, { useState, useEffect } from "react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
// import axios from "axios";
import { Link } from "react-router-dom";
import "../../assets/css/AddedCss.css";
import ApiService from "../../services/httpService";

/**
 * Dashboard is a React component that manages the display of
 * master and user data on the main dashboard page. It fetches
 * data from an API, handles state management for UI elements
 * like tables and modals, and provides user interaction
 * capabilities like viewing and editing user details.
 *
 * @returns {JSX.Element}
 */

const Dashboard = () => {
  const [menu, setMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [MasterMain, setMasterMain] = useState([]);
  const [MasterMainLength, setMasterMaiLength] = useState();
  const [user, setUser] = useState([]);
  const [CountNumber, setCountNumber] = useState([]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const fetchAll = async () => {
    setLoading(true);
    setError(null);

    try {
      const [masterRes, countRes, userRes] = await Promise.all([
        ApiService.getPublic(`api/CenPilot/MasterList`),
        ApiService.getPublic(`api/CenPilot/TotalCount`),
        ApiService.getPublic(`api/CenPilot/UserList`),
      ]);

      const invalidDevice =
        masterRes === "Invalid Device ID." ||
        countRes === "Invalid Device ID." ||
        userRes === "Invalid Device ID.";

      if (invalidDevice) {
        // Show the Bootstrap modal
        const modalElement = document.getElementById("warning-alert-modal");
        const modal = new window.bootstrap.Modal(modalElement);
        modal.show();

        // Clear localStorage and redirect after 3 seconds
        setTimeout(() => {
          localStorage.clear();
          window.location.href = "/login"; // Adjust this route as needed
        }, 3000);

        return;
      }

      // Set data
      setMasterMaiLength(masterRes.length);
      setMasterMain(masterRes.slice(0, 10));
      setCountNumber(countRes);
      setUser(userRes.slice(0, 10));
    } catch (err) {
      console.error("Error fetching data:", err);
      if (
        err?.response?.data === "Invalid Device ID." ||
        err?.message?.includes("Invalid Device ID")
      ) {
        alert("Invalid Device ID. Please log in again.");
        localStorage.clear();
        history.push("/login");
        return;
      }
      setError("Failed to fetch data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAll();
  }, []);

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-1">
                        <i className="fa-solid fa-brain"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Master</div>
                        <div className="dash-counts">
                          <p>{MasterMainLength}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-3">
                        <i className="fas fa-users"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Users</div>
                        <div className="dash-counts">
                          <p>{user.length}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-2">
                        <i className="fa-solid fa-circle-nodes"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Nodes</div>
                        <div className="dash-counts">
                          <p>{CountNumber[2]?.RecordCount}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <span className="dash-widget-icon bg-8">
                        <i className="fa-regular fa-lightbulb"></i>
                      </span>
                      <div className="dash-count">
                        <div className="dash-title">Valves</div>
                        <div className="dash-counts">
                          <p>{CountNumber[0]?.RecordCount}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {loading && (
              <div
                className="spinner-border text-success loading-main"
                role="status"
              />
            )}
            {error && <p className="error-main">{error}</p>}
            {!loading && !error && (
              <div className="row">
                {/* temple */}
                <div className="col-lg-6">
                  <div className="card">
                    <div className="card-header header-flex">
                      <h5 className="card-title">Master Details</h5>
                      <div className="col-auto">
                        <Link
                          to="/master"
                          className="btn-right btn btn-sm btn-outline-primary"
                        >
                          View All
                        </Link>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-hover mb-0">
                          <thead>
                            <tr>
                              <th>Master Name</th>
                              <th>Address</th>
                              <th>Location</th>
                            </tr>
                          </thead>
                          <tbody>
                            {MasterMain.map((item, index) => (
                              <tr key={index}>
                                <td>{item.Name}</td>
                                <td>
                                  {item.Village}, {item.City}
                                </td>
                                <td>
                                  {item.Location ? (
                                    <a
                                      href={`https://www.google.com/maps?q=${item.Location}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View Location
                                    </a>
                                  ) : (
                                    "No Location"
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                {/* all users */}
                <div className="col-lg-6">
                  <div className="card">
                    <div className="card-header header-flex">
                      <h5 className="card-title">All User Details</h5>
                      <div className="col-auto">
                        <Link
                          to="/user"
                          className="btn-right btn btn-sm btn-outline-primary"
                        >
                          View All
                        </Link>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-hover mb-0">
                          <thead>
                            <tr>
                              <th>User Name</th>
                              <th>Address</th>
                              <th>Mobile</th>
                            </tr>
                          </thead>
                          <tbody>
                            {user.map((item, index) => (
                              <tr key={index}>
                                <td>{item.Name}</td>
                                <td>
                                  {item.Address}, {item.City}
                                </td>
                                <td>{item.Phone}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div
              id="warning-alert-modal"
              className="modal fade"
              tabIndex={-1}
              role="dialog"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-sm">
                <div className="modal-content">
                  <div className="modal-body p-4">
                    <div className="text-center">
                      <i className="dripicons-warning h1 text-warning" />
                      <h4 className="mt-2">Incorrect Information</h4>
                      <p className="mt-3">This User Login Another Device...</p>
                      <button
                        type="button"
                        className="btn btn-warning my-2"
                        data-bs-dismiss="modal"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Dashboard;
